import request from '@/api/request'

export function fetchList(data) {
    return request({
        url: '/model-analysis/assessPlan/queryAssessRecordList',
        method: 'post',
        data,
    })
}